<template>
  <div>
    <div class="card">
      <div class="card-header border-transparent">
        <h3 class="card-title">Uygulamalar</h3>
        <div class="card-tools">
          <button
            class="btn btn-sm btn-outline-primary"
            title="Yenile"
            @click="refreshWatchList"
          >
            <i class="fas fa-sync"></i>
          </button>
          <button
            type="button"
            class="btn btn-tool"
            data-card-widget="collapse"
          >
            <i class="fas fa-minus"></i>
          </button>
        </div>
      </div>
      <!-- /.card-header -->
      <div class="card-body p-0">
        <div class="overlay-wrapper">
          <div class="overlay" v-if="overlay">
            <i class="fas fa-3x fa-spinner fa-spin"></i>
          </div>
          <div class="table-responsive" style="max-height: 300px">
            <table class="table m-0">
              <thead>
                <tr>
                  <th style="width: 1%">#</th>
                  <th>Uygulama Adı</th>
                  <th>Bekleyen Talep Sayısı</th>
                  <th>Son Çalışma Zamanı</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in datas"
                  :key="item.id"
                  :class="{ 'bg-danger': item.total >= 10 }"
                >
                  <td>#</td>
                  <td>{{ item.name }}</td>
                  <td>
                    <span v-if="item.total > 0">
                      <strong>Bekleyen {{ item.total }} Talep</strong>
                    </span>
                    <span v-if="item.total == 0">Bekleyen Talep Yok</span>
                  </td>
                  <td>
                    <span :class="{ changed: item.isChange }">{{
                      item.pingDate | DateFormat
                    }}</span>
                  </td>
                </tr>
                <tr v-if="!datas || datas.length === 0">
                  <td colspan="4" class="text-center">Kayıt Bulunamadı</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- /.table-responsive -->
      </div>
      <!-- /.card-body -->
      <div class="card-footer clearfix">
        <router-link
          tag="button"
          :to="'/watch'"
          class="btn btn-primary btn-sm float-right"
          title="Tüm Uygulamalar"
          >Tüm Uygulamalar</router-link
        >
      </div>
      <!-- /.card-footer -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      auth: this.$store.getters.getModules,
      site: this.$store.getters.getSite,
      service: this.$store.getters.getHub,
      datas: [],
      overlay: false,
      now: new Date()
    };
  },
  validations: {},
  filters: {
    DateFormat(value) {
      if (!value) return "Belirtilmemiş";

      let date = value.split("T")[0].split("-");
      let time = value.split("T")[1].split(".")[0];
      return date[2] + "/" + date[1] + "/" + date[0] + " " + time;
    }
  },
  methods: {
    refreshWatchList() {
      this.$store.dispatch("getBotListService");
    }
  },
  computed: {},
  created() {
    this.$store.dispatch("getBotListService");
  },
  destroyed() {},
  watch: {
    "$store.getters.getSite"() {
      this.site = this.$store.getters.getSite;
      this.$store.commit("clearWatchList");
      this.$store.commit("clearBotList");
    },
    "$store.getters.getBotList"() {
      this.datas = this.$store.getters.getBotList;
    }
  }
};
</script>
<style scoped>
.changed {
  font-weight: 700;
  animation: blinker 1s linear infinite;
}
@keyframes blinker {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/WatchList.vue